import { isNil } from './isNil';
// @internal
export function isDefined(val) {
  return isNil(val) === false;
}
